import { z } from 'zod';
import { bindInputMaker } from '../util.make-input.js';

const makeInput = bindInputMaker();
const freetextInput = makeInput({
  entry: {
    schema: z.object({
      type: z.literal("freetext").default("freetext"),
      richtext: z.string().default("")
    }),
    shouldValidate: () => false,
    validate: () => false,
    parseLegacyDetailItem: (item, context) => {
      if (["FreeText"].includes(context.relatedTask.taskType) && item && typeof item === "object" && "input" in item && typeof item.input === "string") {
        return [context.relatedTask.id, {
          type: "freetext",
          richtext: item.input
        }];
      }
    }
  },
  schema: z.object({
    id: z.string(),
    nodeType: z.literal("freetext-input")
  })
});

export { freetextInput };
//# sourceMappingURL=input.freetext.js.map
